import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { MessageService, SelectItem } from 'primeng/api';
import { TagManagerService } from 'src/app/service/tagmanager/tagmanager.service';
import { FormularioCliente } from '../../models/formcliente.component';
import { ClienteService } from '../../service/cliente/cliente.service';
declare var $: any;

@Component({
  templateUrl: './redoxito.html',
  styleUrls: ['./redoxito.css'],
  providers: [MessageService]
})
export class Redoxito implements OnInit {
  public formularioCliente: FormularioCliente;
  // public disabledEnvio: boolean=false;
  public sexos;
  public chk_terminos: any;
  public display: boolean = false;
  closeResult: string;
  public maxLengthDoc: any = 8;
  es: any;
  public comp1Validacion: boolean = false;
  public comp2Validacion: boolean = false;
  public txtComp1Validacion: any = "Validacion";
  public txtComp2Validacion: any = "Validacion 2";
  public styleExpComprobante: any = { 'display': 'none' };

  public maxDate: Date;
  public dates: Date[];
  public rangeDates: Date[];
  public minDate: Date;
  invalidDates: Array<Date>
  public date2: Date;

  public tipsex: SelectItem[];
  public tipdoc: SelectItem[];
  correValido: boolean = false;
  public ronly: boolean;
  public regex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  public regex1 = /^[a-z][\w.-]+@\w[\w.-]+\.[\w.-]*[a-z][a-z]$/i;
  public mensajeResultado: string;
  serieFormulario: string;
  numeroFormulario: string;
  selectTipoDocumento: any;
  selectSexo: any;
  tamanioDocumento: number;
  
  constructor(
    private modalService: NgbModal,
    private _clienteService: ClienteService,
    public _service: MessageService,
    private router: Router,
    private tagManagerService: TagManagerService
  ) {
    this.formularioCliente = new FormularioCliente(null, null, null,
      'Sexo', null, null, null, null, null, null, null, true, null, null, null, null, null, true, null, null, null);
  }

  ngOnInit() {
    this.removeBackgroundImage();
    this.ronly = true;
    this.maxDate = new Date();
    this.formularioCliente = new FormularioCliente(null, null, null, 'Sexo', null, null, null, null, null, null, null, false, null, null, null, null, null, false, null, null, null);
    //inicio de p-calendar
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dec"],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'dd/mm/yy'
    };

    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let day = today.getDay();
    let prevMonth = (month === 0) ? 11 : month - 1;
    let prevYear = (prevMonth === 11) ? year - 1 : year;
    let nextMonth = (month === 11) ? 0 : month + 1;
    let nextYear = (nextMonth === 0) ? year + 1 : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate());

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    this.invalidDates = [today, invalidDate];



    this.tipsex = [];
    this.tipsex.push({ label: 'Sexo', value: 'Sexo' });
    this.tipsex.push({ label: 'Masculino', value: 'Masculino' });
    this.tipsex.push({ label: 'Femenino', value: 'Femenino' });

    this.tipdoc = [];
    this.tipdoc.push({ label: 'Tipo de documento', value: 'Tipo' });
    this.tipdoc.push({ label: 'DNI', value: '01' });
    this.tipdoc.push({ label: 'Carnet de extranjería', value: '02' });

    //this.selectTipoDocumento = "Tipo de Documento";

    $('#inka-dni').attr("readonly", true);
    $('#inka-dni').css("background", "rgb(226, 226, 226)");
    this.selectTipoDocumento="Tipo";

    //this.selectTipoDocumento = "01";

    this.selectSexo = "Sexo";
    //    this.tipdoc.push({ label: 'PASAPORTE', value: '03' });


    /*
            $('#inka-nombres').on('input', function (event) {
              this.value = this.value.replace(/[^A-Za-z ]/g, '');
            });
            $('#inka-paterno').on('input', function (event) {
              this.value = this.value.replace(/[^A-Za-z ]/g, '');
            });
            $('#inka-materno').on('input', function (event) {
              this.value = this.value.replace(/[^A-Za-z ]/g, '');
            });
            $('#inka-numero').on('input', function (event) {
              this.value = this.value.replace(/[^0-9]/g, '');
            });

            $('#inka-dni').on('input', function (event) {
              this.value = this.value.replace(/[^0-9]/g, '');
            });

            $('#inka-celular').on('input', function (event) {
              this.value = this.value.replace(/[^0-9]/g, '');
            });


            $('#inka-serie').keyup(function(e) {
              var max = 4;
              if ($('#inka-serie').val().length > max) {
                $('#inka-serie').val($('#inka-serie').val().substr(0, max));
              }
            });
            $('#inka-numero').keyup(function(e) {
              var max = 8;
              if ($('#inka-numero').val().length > max) {
                $('#inka-numero').val($('#inka-numero').val().substr(0, max));
              }
            });
            $('#inka-dni').keyup(function(e) {
              var max = 12;
              if ($('#inka-dni').val().length > max) {
                $('#inka-dni').val($('#inka-dni').val().substr(0, max));
              }
            });

            $('#inka-celular').keyup(function(e) {
              var max = 9;
              if ($('#inka-celular').val().length > max) {
                $('#inka-celular').val($('#inka-celular').val().substr(0, max));
              }
            });

            $("#inka-serie").keyup(function(e){
              var key = e.keyCode || e.which;
              var tecla = String.fromCharCode(key);
              var letras = [
              'á','é','í','ó','ú','a','b','c','d','e','f','g',
              'h','i','j','k','l','m','n','ñ','o','p','q','r',
              's','t','u','v','w','x','y','z',
              'Á','É','Í','Ó','Ú','A','B','C','D','E','F','G',
              'H','I','J','K','L','M','N','Ñ','O','P','Q','R',
              'S','T','U','V','W','X','Y','Z'
              ];
             var numeros = ['1','2','3','4','5','6','7','8','9','0'];
             var texto = $("#inka-serie").val();
              if(texto.length == 0){
              if(letras.indexOf(tecla) > -1){
              return true;
              }
              else{
              return false;
              }
             }
             if(texto.length > 0){
              if(numeros.indexOf(tecla) > -1){
              return true;
              }
              else{
              return false;
              }
             }
            });
    */
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  OnRegistrar() {
    this.mensajeResultado = '';
    var validar = true;
    var email = this.formularioCliente.correo;
    var politica = this.formularioCliente.check_recibir;
    var suscripcion = this.formularioCliente.check_inkaclub;

    var arregloErrores = [];
    var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    this.formularioCliente.tipoDocEntidad = this.selectTipoDocumento;
    this.formularioCliente.sexo = "";


    if(this.selectTipoDocumento== 'Tipo'){
      arregloErrores.push("Tienes que seleccionar tipo documento.");
      validar = false;
    }

    if (this.serieFormulario == null || this.serieFormulario == "") {
      arregloErrores.push("Tienes que llenar el campo serie.");
      validar = false;
    } else
      if (this.serieFormulario.length > 0) {
        if (this.serieFormulario.length != 4) {
          arregloErrores.push("La serie tiene que tener 4 digitos.");
          validar = false;
        }
      }
    if (this.numeroFormulario == null || this.numeroFormulario == "") {
      arregloErrores.push("Tienes que llenar el campo numero.");
      validar = false;
    }
    if (this.formularioCliente.nombres == null || this.formularioCliente.nombres == "") {
      //$('#inka-nombres').css("border-color", "red");
      //$('#inka-nombres').focus();
      arregloErrores.push("Tienes que llenar el campo nombre.");
      validar = false;
    }
    if (this.formularioCliente.apePaterno == null || this.formularioCliente.apePaterno == "") {
      arregloErrores.push("Tienes que llenar el campo apellido paterno.");
      validar = false;
    }
    if (this.formularioCliente.apeMaterno == null || this.formularioCliente.apeMaterno == "") {
      arregloErrores.push("Tienes que llenar el campo apellido materno.");
      validar = false;
    }
    /*
    if (this.selectSexo == 'Sexo') {
      arregloErrores.push("Tienes que seleccionar un sexo.");
      validar = false;
    }*/

    if (this.formularioCliente.correo == null || this.formularioCliente.correo == "") {
      arregloErrores.push("Tienes que llenar el campo correo.");
      validar = false;
    } else if (this.formularioCliente.correo.length > 0) {
      if (!emailRegex.test(email)) {
        arregloErrores.push("El correo no tiene el formato correcto.");
        validar = false;
      }
    }
    if (this.formularioCliente.celular == null || this.formularioCliente.celular == "") {
      arregloErrores.push("Tienes que llenar el campo celular.");
      validar = false;
    }

    //this.tamanioDocumento = 8; //DNI

    if (this.formularioCliente.dni == null || this.formularioCliente.dni == "") {
      arregloErrores.push("Tienes que llenar el campo numero de documento.");
      validar = false;
    }
    else if (this.formularioCliente.dni.length > 0) {
      if ($("#inka-dni").val().length != this.tamanioDocumento) {
        arregloErrores.push("El numero de documento tiene que tener " + this.tamanioDocumento + " digitos.");
        validar = false;
      }
    }

    /*
    console.log(this.date2);
    if (this.date2 == null) {
      arregloErrores.push("Tienes que llenar el campo fecha de nacimiento del bebé.");
      validar = false;
    }
    */

    if (this.formularioCliente.check_recibir == null || !this.formularioCliente.check_recibir) {
      arregloErrores.push("Aceptar las políticas de privacidad para continuar con el proceso.");
      validar = false;
    }
    if (this.formularioCliente.check_inkaclub == null || !this.formularioCliente.check_inkaclub) {
      arregloErrores.push("Aceptar los tratamiento para finalidades adicionales para continuar con el proceso.");
      validar = false;
    }

    this.mensajeResultado += '<table style="font-weight:bold;"><tbody>';
    if (validar == false) {
      //$("#mensajeResultado").css('margin','0 auto');
      for (let i = 0; i < arregloErrores.length; i++) {
        this.mensajeResultado += "<tr><td>" + Number(i + 1) + ".- " + arregloErrores[i] + "</td></tr>";
      }
      this.mensajeResultado += "</tbody></table>";

      // $("#mensajeResultado").attr("position","center");
      this._service.add({
        key: 'tst',
        severity: 'error',
        summary: 'Atención',
        detail: this.mensajeResultado
      });
    }
    else if (validar == true) {
      this.tagManagerService.sendEvent('registerNinet');
      const dateFormat = "YYYY-MM-DD";
      //console.log(this.date2);
      this.formularioCliente.fechaNacBaby = moment(this.date2).format(dateFormat);

      this.formularioCliente.id_empresa = 1;
      this.formularioCliente.id_proveedor = 121;
      this.formularioCliente.codDepartamento = '014';
      this.formularioCliente.codProvincia = '001';
      this.formularioCliente.codDistrito = '010';
      if (this.formularioCliente.fechaNacimiento == null || this.formularioCliente.fechaNacimiento == '') {
        this.formularioCliente.fechaNacimiento = '';
      }
      if (this.formularioCliente.correo == null || this.formularioCliente.correo == '') {
        this.formularioCliente.correo = '';
      }
      if (this.formularioCliente.sexo == null || this.formularioCliente.sexo == 'Sexo') {
        this.formularioCliente.sexo = '';
      }
      this.formularioCliente.comprobante = this.serieFormulario + '-' + this.numeroFormulario;
      console.log("OBJETO DE FORMULARIOCLIENTE: ");
      console.log(this.formularioCliente);

      this._clienteService.guardarCliente(this.formularioCliente).subscribe(data => {
        this.formularioCliente = new FormularioCliente(null, null, null,
          'Sexo', null, null, null, null, null, null, null, false, null, null, null, null, null, false, null, null,null);
        this.mensajeResultado = "<p>Los datos se han guardado satisfactoriamente.</p>";
        sessionStorage.setItem("status", "success");
        this._service.add({
          key: 'tst', severity: 'success',
          summary: 'EXITO!',
          detail: this.mensajeResultado
        });
        this.router.navigate(['/redoxito']);
      }, err => {
        this.mensajeResultado = "<p>Intentelo mas tarde ha ocurrido un error.</p>";
        this._service.add({
          key: 'tst', severity: 'error',
          summary: 'Atención',
          detail: this.mensajeResultado
        });
      });

    } else {
      console.log('se envia 3 ');

    }

  }
  /*
       if(this.OnValidar()){
         this.formularioCliente.id_empresa=1;
         this.formularioCliente.id_proveedor=15;
         this.formularioCliente.codDepartamento='014';
         this.formularioCliente.codProvincia='001';
         this.formularioCliente.codDistrito='010';

         if(this.formularioCliente.fechaNacimiento==null || this.formularioCliente.fechaNacimiento==''){
                      this.formularioCliente.fechaNacimiento='';
         }
         if(this.formularioCliente.correo==null || this.formularioCliente.correo==''){
                      this.formularioCliente.correo='';
         }
         if(this.formularioCliente.sexo==null || this.formularioCliente.sexo=='Sexo'){
                      this.formularioCliente.sexo='';
         }
         this.formularioCliente.comprobante = $("#inka-serie").val()+'-'+$("#inka-numero").val();
         this._clienteService.guardarCliente(this.formularioCliente).subscribe(data=>{

           this.formularioCliente = new FormularioCliente(null, null, null,
             'Sexo', null,null, null, null, null, null, null, false,null, null, null, null, null, false);

           sessionStorage.setItem("status","success");
           this._service.add({ key: 'tst', severity: 'success', summary: 'EXITO!', detail: 'Se registro con satisfacción!' });
           this.router.navigate(['/']);
         }, err =>{

           this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Hubo un problema, vuelvelo a intentarlo mas tarde.' });
         });

       }else{
         console.log('se envia 3 ');

       }
   */


  OnValidar() {
    this.OnLimpiarValidaciones();
    let firstCampos: boolean = false;
    let valido: boolean = true;

    if (this.formularioCliente.nombres == null) {
      alert("1");
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese su nombre!' });
      valido = false;
    }
    if (this.formularioCliente.apePaterno == null) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese su apellido!' });
      valido = false;
    }
    if (this.formularioCliente.apeMaterno == null) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese su apellido!' });
      valido = false;
    }

    if (this.formularioCliente.celular == null) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese su numero de celular!' });
      valido = false;
    }
    if (this.formularioCliente.dni == null) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese su número de documento de indentidad!' });
      valido = false;
    } else if (this.formularioCliente.dni.length !== 12 && this.formularioCliente.dni.length !== 8) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese numero correcto de documento de indentidad' });
      valido = false;
    }
    if (this.formularioCliente.fechaNacimiento == null) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Ingrese la fecha de nacimiento del bebé!' });
      valido = false;
    }

    if (this.formularioCliente.check_recibir == null || !this.formularioCliente.check_recibir) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Aceptar las políticas de privacidad para continuar con el proceso' });
      valido = false;
    }

    if (this.formularioCliente.check_inkaclub == null || !this.formularioCliente.check_inkaclub) {
      this._service.add({ key: 'tst', severity: 'error', summary: 'Atención', detail: 'Aceptar los tratamiento para finalidades adicionales para continuar con el proceso' });
      valido = false;
    }
    return valido;

  }

  OnValidateEmail() {
    let valor = this.formularioCliente.correo;
    var isValid = this.regex.test(valor);
    if (valor != null || valor != '') {
      if (!isValid) {
        this.correValido = true;
      } else if (isValid) {
        this.correValido = false;
      }
    } else this.correValido = false;
  }

  onTipoDocumentoChange(event) {

    var tipodoc = this.selectTipoDocumento;    

    if (tipodoc === 'Tipo') {
      $('#inka-dni').attr("readonly", true);
      $('#inka-dni').css("background", "rgb(226, 226, 226)");
      this.formularioCliente.dni = "";
    } else {
      $('#inka-dni').attr("readonly", false);
      $('#inka-dni').css("background", "white");
      if (tipodoc === '01') {
        this.tamanioDocumento = 8;
        this.formularioCliente.dni = "";
        $("#inka-dni").attr('maxlength', '8');
      } else if (tipodoc === '02') {
        this.tamanioDocumento = 12;
        this.formularioCliente.dni = "";
        $("#inka-dni").attr('maxlength', '12');
      }
    }
  }


  OnLimpiarValidaciones() {
    this.styleExpComprobante = { 'display': 'none' };
    this.txtComp1Validacion = "";
    this.txtComp2Validacion = "";
  }

  OnRoutingFormularioInkafarma() {
    this.router.navigate(['/inkafarma/']);
  }

  OnCambiarLengthDoc($event: any) {
    if ($event == '01') {
      this.formularioCliente.dni = "";
      this.ronly = false;
      this.maxLengthDoc = 8;
    } else if ($event == '02') {
      this.formularioCliente.dni = "";
      this.maxLengthDoc = 12;
      this.ronly = false;
    } else if ($event == '03') {
      this.formularioCliente.dni = "";
      this.maxLengthDoc = 12;
      this.ronly = false;
    } else if ($event == 'tipo') {
      this.ronly = true;
      this.formularioCliente.dni = "";
    }
  }

  removeBackgroundImage() {
    const body = document.querySelector('body.light-page');
    body.classList.remove('bg-top');
  }

}
